import React, { Component } from 'react';
import API from '@/api/api';
import zhCN from 'antd/es/locale/zh_CN';
import { Table, Button, ConfigProvider, message } from 'antd';

// /insuranceBroker/participantsList

class InvitationList extends Component {

  constructor(props) {
    super(props);
  }

  state = {

    columns: [//直播列表表头
      {
        title: '用户ID',
        dataIndex: 'userId',
      },
      {
        title: '用户昵称',
        dataIndex: 'nickName',
      },
      {
        title: '用户手机号',
        dataIndex: 'userPhone',
      },
      {
        title: '报名时间',
        dataIndex: 'joinTimeFormat',
      },
      {
        title: '姓名',
        dataIndex: 'userName',
      },
      {
        title: '身份证号',
        dataIndex: 'idNum',
      },
      {
        title: '从业年限',
        dataIndex: 'workYear',
      },
      {
        title: '就职保司',
        dataIndex: 'companyName',
      },
      {
        title: '生日',
        dataIndex: 'birthday',
      },
      {
        title: '资格审核',
        dataIndex: 'statusStr',
      },
      {
        title: '活动ID',
        dataIndex: 'activityId',
      },
      {
        title: '活动名称',
        dataIndex: 'title',
      },
      {
        title: '报名申请',
        dataIndex: 'memberStatus',
        render: (memberStatus, record) => (
          memberStatus == '1' ? '已通过' :
            memberStatus == '2' ? '已拒绝' :
              (memberStatus == '0' && record.statusType != 6) ? <>
                <Button type="primary" onClick={this.playThdAudit.bind(this, record, '1')}>通过</Button>
                <Button type="danger" style={{ marginLeft: '20px' }} onClick={this.playThdAudit.bind(this, record, '2')}>拒绝</Button>
              </> : ''
        ),
      },
      {
        title: '签到',
        dataIndex: 'isSign',
        render: (joinSalonStatus, record) => (
          joinSalonStatus == '1' ? '已签到' :
            record.statusType != 6 ?
              <Button type="primary" onClick={this.thdSign.bind(this, record.memberId)}>签到</Button> : ''
        ),
      }
    ],

    searchCondition: {
      pageSize: 5,
      pageNo: 1,
    },

    pagination: {
      defaultPageSize: 5,
      hideOnSinglePage: true,
      showTotal: total => `总${total}条`,
      onChange: this.onPaginationChange.bind(this),
    },
  }

  componentDidMount() {
    let { activityId } = this.props.location.state;
    let { searchCondition } = this.state;
    searchCondition.activityId = activityId;
    this.setState({ searchCondition }, () => {
      this.getListData()
    })
  }

  componentWillReceiveProps() {
    // this.getListData();
  }

  async thdSign(memberId) {
    let { activityId } = this.props.location.state;
    let result = await API.thdSign({ memberId, activityId })
    if (result.status == 1) {
      this.getListData();
      return
    }
    message.error(result.msg)
  }

  async playThdAudit(record, status) {
    let { activityId } = this.props.location.state;
    const { userId } = record
    let result = await API.playThdAudit({ userId, activityId, status })
    if (result.status == 1) {
      this.getListData();
      return
    }
    message.error(result.msg)
  }


  onPaginationChange(page, pageSize) {
    let { searchCondition } = this.state;
    searchCondition.pageNo = page;
    this.setState({ searchCondition }, () => {
      this.getListData()
    })
  }

  async getListData() {
    let { searchCondition, pagination } = this.state;
    let result = await API.memberList(searchCondition)
    if (result.status == 1) {
      let data = result.data;
      pagination.total = Number(data.totalNum);
      this.setState({
        datas: data.datas,
        pagination
      })
    }
  }


  render() {
    const {
      pagination,
      columns,
      datas,
    } = this.state;
    return (
      <ConfigProvider locale={zhCN}>
        <div className="BrokerList">
          <Table
            columns={columns}
            dataSource={datas}
            pagination={pagination}
            onChange={this.handleTableChange}
            rowKey='userId'
          />
        </div>
      </ConfigProvider>
    )
  }
}

export default InvitationList;